/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveSuspension
 */
export interface ActiveSuspension {
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    matchId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    sourceEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    teamSide?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    rosterEntryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    playerId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActiveSuspension
     */
    startedAtEffectiveElapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveSuspension
     */
    durationMs?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveSuspension
     */
    expiresAtEffectiveElapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveSuspension
     */
    remainingMs?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveSuspension
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof ActiveSuspension
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the ActiveSuspension interface.
 */
export function instanceOfActiveSuspension(value: object): value is ActiveSuspension {
    return true;
}

export function ActiveSuspensionFromJSON(json: any): ActiveSuspension {
    return ActiveSuspensionFromJSONTyped(json, false);
}

export function ActiveSuspensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveSuspension {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'sourceEventId': json['sourceEventId'] == null ? undefined : json['sourceEventId'],
        'teamSide': json['teamSide'] == null ? undefined : json['teamSide'],
        'rosterEntryId': json['rosterEntryId'] == null ? undefined : json['rosterEntryId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'startedAtEffectiveElapsedMs': json['startedAtEffectiveElapsedMs'] == null ? undefined : json['startedAtEffectiveElapsedMs'],
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'expiresAtEffectiveElapsedMs': json['expiresAtEffectiveElapsedMs'] == null ? undefined : json['expiresAtEffectiveElapsedMs'],
        'remainingMs': json['remainingMs'] == null ? undefined : json['remainingMs'],
        'status': json['status'] == null ? undefined : json['status'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ActiveSuspensionToJSON(json: any): ActiveSuspension {
    return ActiveSuspensionToJSONTyped(json, false);
}

export function ActiveSuspensionToJSONTyped(value?: ActiveSuspension | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'matchId': value['matchId'],
        'sourceEventId': value['sourceEventId'],
        'teamSide': value['teamSide'],
        'rosterEntryId': value['rosterEntryId'],
        'playerId': value['playerId'],
        'startedAtEffectiveElapsedMs': value['startedAtEffectiveElapsedMs'],
        'durationMs': value['durationMs'],
        'expiresAtEffectiveElapsedMs': value['expiresAtEffectiveElapsedMs'],
        'remainingMs': value['remainingMs'],
        'status': value['status'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

